// extracted by mini-css-extract-plugin
module.exports = {"card":"podercard_card__b91FT","podercardContent":"podercard_podercardContent__n0t6f","button":"podercard_button__NkySD","poderCardImage":"podercard_poderCardImage___drQb"};